export const LIBRARIES_ALL = 'all'

export enum LIBRARY_ROUTE {
  BROWSE = 'BROWSE',
  RECOMMENDED = 'RECOMMENDED',
  COLLECTIONS = 'COLLECTIONS',
  READLISTS = 'READLISTS'
}
